import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldlayoutsConfigRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-config',
	path: '/secure/admin/ConfigureFieldLayout([!%]?[\\w]*).jspa',
};
